var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6641 18.5729C14.6016 19.2604 16.5938 20.8646 18 20.75C19.2891 20.8646 21.2812 19.2604 22.2188 18.5729C30.7734 12.8438 30.6562 12.8438 33 11.125V9.75C33 8.26042 31.7109 7 30.1875 7H5.8125C4.17188 7 3 8.26042 3 9.75V11.125C5.22656 12.8438 5.10938 12.8438 13.6641 18.5729ZM24.3281 21.5521C23.0391 22.4688 20.6953 24.5312 18 24.4167C15.1875 24.5312 12.8438 22.4688 11.5547 21.5521C6.28125 18 4.28906 16.625 3 15.7083V26.25C3 27.8542 4.17188 29 5.8125 29H30.1875C31.7109 29 33 27.8542 33 26.25V15.7083C31.5938 16.625 29.6016 18 24.3281 21.5521Z",
    fill: "#020E16"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c554dd7947b85bbd5b2a9642086aed8d.svg";
export { ForwardRef as ReactComponent };